import React, { useState, useEffect } from "react";
import { Row, Col, Card, Divider, Menu, Dropdown, Input } from "antd";
import "./index.css";
import Tabs from "../tab/index";
import {
  AiOutlineSearch,
  RiMenuAddLine,
  BsCalendarMinus,
} from "react-icons/all";
import TableWrapper from "../Grid";
import moment from "moment";
import { useHistory } from "react-router-dom";
import RadioWrapper from "../RadioWrapper";
import { GrClose } from "react-icons/gr";
export default function PlantOrder({
  inputText,
  Orders,
  onChangeTab,
  metaData,
  currentPage,
  previousPage,
  onChangeText,
  isLoader,
  onChangeFilter,
  onChangePeriod,
}) {
  const [isClose, setIsclose] = useState(false);
  const [radioValue, setRadioValue] = useState("");
  const history = useHistory();
  const [isVisible, setVisible] = useState(false);
  const [periodValue, setPeriodValue] = useState("");
  const [value1, setValue1] = useState("");
  const [value2, setValue2] = useState("");

  let days = [];
  let daysRequired = 7;
  let nextDays = [];

  for (let i = daysRequired; i >= 1; i--) {
    days.push(
      moment()
        .add(i + 1, "days")
        .format("dddd, D")
    );
  }
  for (let i = daysRequired; i >= 1; i--) {
    nextDays.push(
      moment()
        .add(i + 1, "days")
        .format("YYYY-MM-DD")
    );
  }
  console.log("NEXT_DAYS", nextDays.reverse());

  useEffect(() => {
    onChangeFilter(nextDays[value2], nextDays[value1]);
  }, [value1, value2]);

  const saveDates = days.reverse().map((item) => {
    const ab = item.split(",");
    return { key: ab[0].charAt(0), value: ab[1] };
  });
  const columns = [
    {
      title: "ORDER DETAILS",
      dataIndex: "",
      align: "left",
      sortDirections: ["descend", "ascend"],
      key: "rmx_product",

      sorter: (a, b) =>
        a.order_products[0]?.rmx_product?.name.localeCompare(
          b.order_products[0]?.rmx_product?.name
        ),
      render: (r) => {
        return (
          <div>
            <h1 className="font-w-700">{`Order# ${r?.order_number}`}</h1>
            <p>{r?.order_products[0]?.rmx_product?.name}</p>
          </div>
        );
      },
    },
    {
      title: "CONTRACTOR",
      dataIndex: "",
      align: "left",
      key: "first_name",

      sorter: (a, b) =>
        a.contractor?.user?.first_name.localeCompare(
          b.contractor?.user?.first_name
        ),
      render: (r) => {
        return (
          <div>
            <h1 className="font-w-700">{`${r?.contractor?.user?.first_name} ${r?.contractor?.user?.last_name}`}</h1>
            <p>{r?.contractor?.user?.phone}</p>
          </div>
        );
      },
    },
    {
      title: "DATE",
      dataIndex: "",
      align: "left",
      render: (r) => (
        <div class="chip chips-s">
          {/* <Row>
            <Col
              xs={24}
              sm={24}
              xl={24}
              lg={24}
              style={{ border: "1px solid red" }}
            > */}
          <span class="pm-circle am-pm-circle">
            {r?.preferred_delivery_period}
          </span>
          <span style={{ marginRight: "5px" }}>
            <BsCalendarMinus size="12" />
          </span>
          <span>
            {moment(r?.preferred_delivery_datetime).format("MM-DD-YYYY")}
          </span>
          {/* </Col>
          </Row> */}
        </div>
      ),
    },
    {
      title: "PRICE",
      dataIndex: "total_amount",
      align: "left",
      render: (r) => <p>{`$ ${r}`}</p>,
    },
    {
      title: "ACTION",
      dataIndex: "",
      align: "left",
      render: (r) => (
        <p
          className="st-primary pointer-cursor "
          onClick={() => history.push(`/order/${r.id}`)}
        >
          Details
        </p>
      ),
    },
  ];
  console.log("value==>", nextDays[value1], nextDays[value2]);
  const menu = (
    <Menu>
      <Row>
        <Col span={4}>
          <RadioWrapper
            name="abc"
            value={"last7days"}
            checked={radioValue === "last7days"}
            onChange={() => {
              onChangeFilter(
                moment().format("YYYY-MM-DD"),
                moment().subtract(1, "weeks").format("YYYY-MM-DD")
              );
              setRadioValue("last7days");
            }}
          />
          {/* <input type="radio" /> */}
        </Col>
        <Col xl={12}>
          <p> Last 7 Days</p>
        </Col>
      </Row>
      <Row>
        <Col span={4}>
          <RadioWrapper
            name="abc"
            value={"lastMonth"}
            checked={radioValue === "lastMonth"}
            onChange={() => {
              onChangeFilter(
                moment().format("YYYY-MM-DD"),
                moment().subtract(1, "month").format("YYYY-MM-DD")
              );

              setRadioValue("lastMonth");
            }}
          />
        </Col>
        <Col xl={12}>
          <p> Last Month</p>
        </Col>
      </Row>
      <Row>
        <Col span={4}>
          <RadioWrapper
            name="abc"
            value={"date"}
            checked={radioValue === "date"}
            style={{ cursor: "pointer" }}
            onChange={(e) => {
              setRadioValue("date");
            }}
          />
        </Col>
        <Col xl={12}>
          <p> Date</p>
        </Col>
        <Col xl={24} style={{ height: "4rem", background: "#F1F1F1" }}>
          <Row justify="space-between" style={{ margin: "auto" }}>
            {saveDates.map((v, index) => {
              const sp = days[index].split(",");

              return (
                <>
                  <Col span={3}>
                    <p
                      style={{
                        textAlign: "center",
                        color: sp[0] === "Sunday" ? "red" : "grey",
                        fontSize: "13px",
                      }}
                    >
                      {v.key}
                    </p>
                  </Col>
                </>
              );
            })}
          </Row>
          <Row justify="space-between" style={{ margin: "auto" }}>
            {saveDates.map((v, index) => {
              return (
                <>
                  <Col span={3}>
                    <p
                      className="pointer-cursor"
                      style={{
                        backgroundColor:
                          saveDates[value1]?.value === v.value
                            ? "#19ABAA"
                            : saveDates[value2]?.value === v.value
                            ? "#AB4119"
                            : "",
                        height: "22px",
                        width: "22px",
                        borderRadius: "50%",
                        display: "inline-block",
                        textAlign: "center",
                        color:
                          saveDates[value1]?.value === v.value
                            ? "white"
                            : saveDates[value2]?.value === v.value
                            ? "white"
                            : "black",
                      }}
                      onClick={() => {
                        if (value1 === index) {
                          setValue1("");
                          return;
                        }
                        if (value2 === index) {
                          setValue2("");
                          return;
                        }
                        if (value1 === "") {
                          setValue1(index);
                          return;
                        }
                        if (value2 === "") {
                          setValue2(index);
                          return;
                        }

                        // if (value1 === index) {
                        //   setValue1("");
                        //   return;
                        // }

                        // if (value2 === v.value) {
                        //   setValue2("");
                        // }
                      }}
                    >
                      {v.value}
                    </p>
                  </Col>
                </>
              );
            })}
          </Row>
        </Col>
      </Row>
      <Row>
        <Col xl={6}>
          <p>Time</p>
        </Col>
        <Col xl={8}>
          <RadioWrapper
            value={"am"}
            checked={periodValue === "am"}
            onChange={() => {
              onChangePeriod("am");
              setPeriodValue("am");
            }}
          />
          <span>AM</span>
        </Col>

        <Col xl={6}>
          <RadioWrapper
            value={"pm"}
            checked={periodValue === "pm"}
            onChange={() => {
              onChangePeriod("pm");
              setPeriodValue("pm");
            }}
          />
          <span>PM</span>
        </Col>
      </Row>
    </Menu>
  );

  return (
    <>
      <Row justify="start">
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          style={{ marginTop: "1.5em" }}
        >
          <Row justify="start">
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="custom">
              <Card style={{ padding: "1rem" }}>
                <Row justify="space-between">
                  <Col xl={12} xs={24} sm={24} md={10} lg={12}>
                    <Row>
                      <Col xl={24} xs={24} sm={18} md={17}>
                        <h5 className="text-left">Plant Order Queue</h5>
                      </Col>
                      {radioValue === "last7days" && (
                        <Col
                          style={{
                            padding: "6px",
                            borderRadius: "30px",
                            border: "solid black 1px",
                            marginLeft: "5px",
                          }}
                          span={6}
                        >
                          {" "}
                          <span>Last 7 Days</span>{" "}
                          <span
                            className="pointer-cursor"
                            onClick={() => {
                              setRadioValue("");
                              onChangeFilter();
                            }}
                          >
                            X
                          </span>
                        </Col>
                      )}
                      {radioValue === "lastMonth" && (
                        <Col
                          style={{
                            padding: "6px",
                            borderRadius: "30px",
                            border: "solid black 1px",
                            marginLeft: "5px",
                          }}
                          span={6}
                        >
                          {" "}
                          <span>Last Month</span>{" "}
                          <span
                            className="pointer-cursor"
                            style={{ marginLeft: "3px" }}
                            onClick={() => {
                              setRadioValue("");
                              onChangeFilter();
                            }}
                          >
                            X
                          </span>
                        </Col>
                      )}
                      {periodValue === "am" && (
                        <Col
                          style={{
                            padding: "6px",
                            borderRadius: "30px",
                            border: "solid black 1px",
                            marginLeft: "5px",
                          }}
                          span={6}
                        >
                          {" "}
                          <span>{"Am"}</span>{" "}
                          <span
                            className="pointer-cursor"
                            style={{ marginLeft: "3px" }}
                            onClick={() => {
                              setPeriodValue("");
                              onChangeFilter();
                            }}
                          >
                            X
                          </span>
                        </Col>
                      )}

                      {periodValue === "pm" && (
                        <Col
                          style={{
                            padding: "6px",
                            borderRadius: "30px",
                            border: "solid black 1px",
                            marginLeft: "5px",
                          }}
                          span={6}
                        >
                          {" "}
                          <span>{"Pm"}</span>{" "}
                          <span
                            className="pointer-cursor"
                            style={{ marginLeft: "3px" }}
                            onClick={() => {
                              setPeriodValue("");
                              onChangeFilter();
                            }}
                          >
                            X
                          </span>
                        </Col>
                      )}

                      {nextDays?.[value1] && nextDays?.[value2] && (
                        <Col
                          style={{
                            padding: "6px",
                            borderRadius: "30px",
                            border: "solid black 1px",
                            marginLeft: "5px",
                          }}
                          span={8}
                        >
                          {" "}
                          <span>
                            {nextDays?.[value2]}-{nextDays?.[value1]}
                          </span>{" "}
                          <span
                            className="pointer-cursor"
                            style={{ marginLeft: "3px" }}
                            onClick={() => {
                              setValue1("");
                              setValue2("");
                              onChangeFilter();
                            }}
                          >
                            X
                          </span>
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col style={{ display: "flex" }}>
                    <AiOutlineSearch
                      size="25"
                      onClick={() => setIsclose(!isClose)}
                      className="pointer-cursor"
                      style={{ marginRight: "5px" }}
                    />
                    <Input
                      placeholder="Search..."
                      style={{
                        width: isClose ? "150px" : "0px",
                        padding: 3,
                        background: "transparent",
                        border: "none",
                        borderBottom: "none",
                      }}
                      onChange={onChangeText}
                    />
                    {isClose ? (
                      <GrClose
                        size="20"
                        onClick={() => setIsclose(!isClose)}
                        style={{ marginRight: "20px" }}
                        className="pointer-cursor"
                      />
                    ) : null}
                    <span className="filter-dropdown">
                      <Dropdown
                        overlay={menu}
                        trigger={["click"]}
                        visible={isVisible}
                        className="dropdown-class"
                      >
                        <RiMenuAddLine
                          onClick={(e) => {
                            setVisible(!isVisible);
                            setValue1("");
                            setValue2("");
                          }}
                          size="20"
                          className="pointer-cursor"
                        />
                      </Dropdown>
                    </span>
                  </Col>

                  <Divider
                    className="ant-divider-horizontal"
                    orientation="right"
                  ></Divider>
                </Row>
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Tabs
                      onChangeTab={onChangeTab}
                      plantData={[
                        {
                          key: "PENDING",
                          component: () => (
                            <TableWrapper
                              tableData={Orders}
                              tableColumns={columns}
                              metaData={metaData}
                              currentPage={currentPage}
                              previousPage={previousPage}
                              isLoader={isLoader}
                              fromOrder={true}
                            />
                          ),
                        },
                        {
                          key: "APPROVED",
                          component: () => (
                            <TableWrapper
                              tableData={Orders}
                              tableColumns={columns}
                              metaData={metaData}
                              currentPage={currentPage}
                              previousPage={previousPage}
                              isLoader={isLoader}
                              fromOrder={true}
                            />
                          ),
                        },
                        {
                          key: "DISPATCHED",
                          component: () => (
                            <TableWrapper
                              tableData={Orders}
                              tableColumns={columns}
                              metaData={metaData}
                              currentPage={currentPage}
                              previousPage={previousPage}
                              isLoader={isLoader}
                              fromOrder={true}
                            />
                          ),
                        },
                        {
                          key: "REJECTED",
                          component: () => (
                            <TableWrapper
                              tableData={Orders}
                              tableColumns={columns}
                              metaData={metaData}
                              currentPage={currentPage}
                              previousPage={previousPage}
                              isLoader={isLoader}
                              fromOrder={true}
                            />
                          ),
                        },
                        {
                          key: "COMPLETED",
                          component: () => (
                            <TableWrapper
                              tableData={Orders}
                              tableColumns={columns}
                              metaData={metaData}
                              currentPage={currentPage}
                              previousPage={previousPage}
                              isLoader={isLoader}
                              fromOrder={true}
                            />
                          ),
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
